const FETCH_FRUITS_REQUEST = "FETCH_FRUITS_REQUEST";
const FETCH_FRUITS_SUCCESS = "FETCH_FRUITS_SUCCESS";
const FETCH_FRUITS_ERROR = "FETCH_FRUITS_ERROR";

const GROUP_BY_FRUITS = "GROUP_BY_FRUITS";

export {
  FETCH_FRUITS_REQUEST,
  FETCH_FRUITS_SUCCESS,
  FETCH_FRUITS_ERROR,
  GROUP_BY_FRUITS,
};
